const styles = {
    global: props => ({

    })
  };
  
  export default styles;